export default {
    email: {
        required: 'E-mail address missing',
        empty: 'E-mail address missing',
        email: 'Format of e-mail address invalid',
        duplicate: 'E-mail address already in use'
    },
    firstName: {
        required: 'First name missing',
        empty: 'First name missing'
    },
    lastName: {
        required: 'Last name missing',
        empty: 'Last name missing'
    },
    locale: {
        required: 'Language missing',
        empty: 'Language missing',
        only: 'Invalid language, allowed is "{locales}"'
    },
    roles: {
        required: 'Role missing',
        empty: 'Role missing',
        only: 'Invalid role, allowed is "ROLE_USER" or "ROLE_TREND_MANAGER"',
        capacity: 'The maximum number ({cnt}) in the role {role} has already been reached'
    },
    locked: {
        required: 'Locked missing',
        empty: 'Locked missing',
        only: 'Invalid value, "yes" or "no" is permitted'
    },
    salutation: {
        required: 'Salutation missing',
        empty: 'Salutation missing',
        any: 'Invalid value, "Mr" or "Mrs" is allowed'
    }
}
